
export const sortStatuses = (statuses) => {
  if (!statuses || !Array.isArray(statuses)) return statuses;
  
  const hasExplicitOrder = statuses.some(s => s.order != null && !isNaN(parseInt(s.order)));
  
  if (hasExplicitOrder) {
    return [...statuses].sort((a, b) => {
      let orderA = parseInt(a.order);
      if (isNaN(orderA)) orderA = 9999;
      
      let orderB = parseInt(b.order);
      if (isNaN(orderB)) orderB = 9999;
      
      if (orderA !== orderB) return orderA - orderB;
      return a.name.localeCompare(b.name);
    });
  }

  const defaultOrder = [
    "New Lead", "New", 
    "Schedule", "Scheduled", 
    "Reschedule", "Rescheduled", 
    "Negotiating", "In Negotiation", 
    "Complete(Won)", "Completed", "Won", 
    "Lost", "Not Interested"
  ];
  return [...statuses].sort((a, b) => {
    const indexA = defaultOrder.indexOf(a.name);
    const indexB = defaultOrder.indexOf(b.name);
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.name.localeCompare(b.name);
  });
};

export const getStatusColors = (statusName) => {
  const name = statusName?.trim()?.toLowerCase() || "";
  
  if (["won", "completed", "complete", "complete(won)", "convert", "delivered"].some(s => name.includes(s))) {
    return { bg: "#dcfce7", text: "#166534", dot: "#10b981" }; // Green
  }
  if (["lost", "closed", "cancel", "not interested"].some(s => name.includes(s))) {
    return { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444" }; // Red
  }
  if (["rescheduled", "reschedule"].some(s => name.includes(s))) {
    return { bg: "#ffedd5", text: "#c2410c", dot: "#f97316" }; // Orange
  }
  if (["pending", "follow-up", "follow up"].some(s => name.includes(s))) {
    return { bg: "#fef3c7", text: "#b45309", dot: "#f59e0b" }; // Amber
  }
  if (["scheduled", "schedule"].some(s => name.includes(s))) {
    return { bg: "#f3e8ff", text: "#7e22ce", dot: "#a855f7" }; // Purple
  }
  if (["negotiation", "in negotiation", "out for delivery", "in progress"].some(s => name.includes(s))) {
    return { bg: "#e0e7ff", text: "#4338ca", dot: "#6366f1" }; // Indigo
  }
  if (["hold", "on hold", "waiting"].some(s => name.includes(s))) {
    return { bg: "#f1f5f9", text: "#475569", dot: "#64748b" }; // Slate/Gray
  }
  
  // Default (New Lead, etc.)
  return { bg: "#dbeafe", text: "#1e40af", dot: "#3b82f6" }; // Blue
};

